import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import { Select } from './Select'

const languages = [
  { code: 'pt', name: 'PT', fullName: 'Português', flag: '🇧🇷' },
  { code: 'en', name: 'EN', fullName: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'ES', fullName: 'Español', flag: '🇪🇸' },
]

interface LanguageSwitcherProps {
  className?: string
  variant?: 'dropdown' | 'buttons' | 'minimal'
  showBackground?: boolean
}

export function LanguageSwitcher({
  className,
  variant = 'minimal',
  showBackground = true,
}: LanguageSwitcherProps) {
  const { i18n } = useTranslation()

  if (variant === 'dropdown') {
    return (
      <Select
        aria-label="Language"
        value={i18n.language.slice(0, 2)}
        onChange={(code) => i18n.changeLanguage(code)}
        className={cn('font-medium', className)}
        options={languages.map((lang) => ({
          value: lang.code,
          label: `${lang.flag} ${lang.fullName}`,
          textValue: lang.fullName,
        }))}
      />
    )
  }

  if (variant === 'buttons') {
    return (
      <div className={cn('flex gap-2', className)}>
        {languages.map((lang) => (
          <button
            key={lang.code}
            type="button"
            onClick={() => i18n.changeLanguage(lang.code)}
            className={cn(
              'px-3 py-2 text-sm font-medium rounded-lg transition-all',
              i18n.language === lang.code
                ? 'bg-primary text-primary-foreground'
                : 'bg-muted text-foreground hover:bg-muted/80'
            )}
          >
            {lang.flag} {lang.name}
          </button>
        ))}
      </div>
    )
  }

  // Minimal variant - just flags
  return (
    <div className={cn('flex gap-2', showBackground && 'p-2 bg-muted rounded-full', className)}>
      {languages.map((lang) => (
        <button
          key={lang.code}
          type="button"
          onClick={() => i18n.changeLanguage(lang.code)}
          title={lang.fullName}
          className={cn(
            'p-2 text-2xl rounded-full transition-all hover:scale-110',
            i18n.language === lang.code
              ? showBackground
                ? 'bg-card shadow-sm'
                : 'bg-primary/10'
              : 'hover:bg-muted'
          )}
        >
          {lang.flag}
        </button>
      ))}
    </div>
  )
}
